export default "__VITE_ASSET__65f43f18__"